import React, { useState } from 'react';
import { Button, Form, Row, Col, Table } from 'react-bootstrap';
import { NumberFormatBase, NumericFormat } from 'react-number-format'; // Corrigido para importar NumericFormat
import './index.css';
import { MaskedNumber } from 'imask';
import PhoneInput from 'react-phone-number-input/input';
import MaskedInput from 'react-text-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faLightbulb,
    faPhone,
} from '@fortawesome/free-solid-svg-icons';

const CalculadoraRPA = () => {
    const [dados, setDados] = useState({
        tipoContrato: '',
        ganhoBruto: '',
        atividade: '',
        nome: '',
        telefone: '',
        email: '',
    });

    const [resultados, setResultados] = useState({
        ganhoBruto: 0,
        das: 0,
        inss: 0,
        impostoRenda: 0,
        iss: 0,
        totalDescontos: 0,
        ganhoLiquido: 0,
    });
    const [resultadosPJ, setResultadosPJ] = useState({
        ganhoBruto: 0,
        das: 0,
        inss: 0,
        impostoRenda: 0,
        iss: 0,
        totalDescontos: 0,
        ganhoLiquido: 0,
    });

    const [step, setStep] = useState('calculadora');
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados({ ...dados, [name]: value });
    };

    const handleCalculate = async () => {
        if (
            dados.ganhoBruto.length > 0 &&
            dados.nome.length > 0 &&
            dados.email.length > 0
        ) {
            await sendEmail();
            calcularAutonomo();
            calcularPJ();
            setStep('resultado');
        } else {
            alert('Preencha todos os campos para calcular o seu RPA!');
        }
    };

    const calcularPJ = () => {
        const ganhoBruto = parseFloat(dados.ganhoBruto);

        if (isNaN(ganhoBruto) || ganhoBruto <= 0) {
            alert('Insira um valor válido para o ganho bruto.');
            return;
        }

        const das = (ganhoBruto * 6) / 100;
        const inss = (ganhoBruto * 4.7709) / 100;
        const impostoRenda = (ganhoBruto * 0) / 100;
        const iss = ganhoBruto * 0.0;
        const totalDescontos = das + inss + impostoRenda + iss;
        const ganhoLiquido = ganhoBruto - totalDescontos;

        setResultadosPJ({
            ganhoBruto,
            das,
            inss,
            impostoRenda,
            iss,
            totalDescontos,
            ganhoLiquido,
        });

        setTimeout(() => {
            window.scrollTo({
                top: 750,
                behavior: 'smooth', // Adiciona uma animação suave
            });
        }, 900);
    };

    const calcularAutonomo = () => {
        const ganhoBruto = parseFloat(dados.ganhoBruto);

        if (isNaN(ganhoBruto) || ganhoBruto <= 0) {
            alert('Insira um valor válido para o ganho bruto.');
            return;
        }

        const das = ganhoBruto * 0.0;
        const inss = ganhoBruto * 0.11;
        const impostoRenda = (ganhoBruto * 2.4516) / 100;
        const iss = ganhoBruto * 0.05;
        const totalDescontos = das + inss + impostoRenda + iss;
        const ganhoLiquido = ganhoBruto - totalDescontos;

        setResultados({
            ganhoBruto,
            das,
            inss,
            impostoRenda,
            iss,
            totalDescontos,
            ganhoLiquido,
        });
    };

    const sendEmail = async () => {
        const url =
            'http://apiemail.bckcode.com.br/api_email/public/api/send-mail';

        let body = '<h1>Novo cálculo RPA realizado!</h1><br>';
        body += `<strong>Nome</strong>: ${dados.nome}<br>`;
        body += `<strong>Email</strong>: ${dados.email}<br>`;
        body += `<strong>Telefone</strong>: ${dados.telefone}<br>`;
        body += `<strong>Tipo Contrato</strong>: ${dados.tipoContrato}<br>`;
        body += `<strong>Atividade</strong>: ${dados.atividade}<br>`;
        body += `<strong>Ganho Bruto</strong>: ${formatarParaReal(
            parseFloat(dados.ganhoBruto)
        )}<br>`;

        const emailData = {
            corpo: body,
            assunto: 'Novo cálculo RPA realizado!',
            para: 'contato@contabilidadeolimpia.com.br',
            de: 'webservices@splbeneficios.com',
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(emailData),
            });

            if (!response.ok) {
                throw new Error('Erro ao enviar o email');
            }

            const result = await response.json();
            setStatus('Email enviado com sucesso!');
            console.log(result);
        } catch (error) {
            setStatus(`Falha ao enviar email: ${error.message}`);
        }
    };

    function formatarParaReal(valor) {
        return valor.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    }

    return (
        <>
            <Row style={{ marginBottom: '150px' }}>
                <Col sm={12} md={12} lg={8}>
                    <div className="main">
                        <div className="container mt-4 pt-3">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                                className="mb-5"
                            >
                                <img
                                    src="https://www.contabilidadeolimpia.com.br/wp-content/uploads/2022/05/logo-contabilidade-olimpia-transparente.png"
                                    width={250}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <h2
                                    className="mt-2 text-center mb-2"
                                    style={{
                                        color: '#002868',
                                        marginTop: '15px',
                                        fontSize: '24px', // Tamanho da fonte ajustado
                                    }}
                                >
                                    Calculadora RPA
                                </h2>
                                <p
                                    className="mt-2 text-center mb-5"
                                    style={{
                                        maxWidth: 500,
                                        fontSize: '16px',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    Faça o cálculo de impostos de forma online e
                                    descubra como você pode economizar ao emitir
                                    notas fiscais com um CNPJ.
                                </p>
                            </div>

                            <Form className="text-center">
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="tipoContrato">
                                            <Form.Label>
                                                Sou contratante ou contratado?*
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="tipoContrato"
                                                value={dados.tipoContrato}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    Selecione
                                                </option>
                                                <option value="Contratante">
                                                    Contratante
                                                </option>
                                                <option value="Contratado">
                                                    Contratado
                                                </option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="ganhoBruto">
                                            <Form.Label>
                                                Meu ganho bruto mensal*
                                            </Form.Label>
                                            <NumericFormat
                                                className="form-control"
                                                name="ganhoBruto"
                                                value={dados.ganhoBruto}
                                                onValueChange={(values) =>
                                                    setDados({
                                                        ...dados,
                                                        ganhoBruto:
                                                            values.value,
                                                    })
                                                }
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                prefix="R$ "
                                                decimalScale={2} // Define a quantidade de casas decimais (2 para centavos)
                                                fixedDecimalScale={true} // Garante que o valor tenha sempre 2 casas decimais
                                                isNumericString
                                                placeholder="R$ 3.500,00"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={6}>
                                        <Form.Group controlId="atividade">
                                            <Form.Label>
                                                Minha atividade*
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="atividade"
                                                value={dados.atividade}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    Selecione
                                                </option>

                                                {dados.tipoContrato ===
                                                    'Contratado' && (
                                                    <>
                                                        <option value="PJ em uma empresa">
                                                            PJ em uma empresa
                                                        </option>
                                                        <option value="Serviços de TI">
                                                            Serviços de TI
                                                        </option>
                                                        <option value="Serviços Administrativos">
                                                            Serviços
                                                            administrativos
                                                        </option>
                                                        <option value="Comércio">
                                                            Comércio
                                                        </option>
                                                        <option value="Medicina">
                                                            Medicina
                                                        </option>
                                                        <option value="Psicologia/outros - Saúde">
                                                            Psicologia/outros -
                                                            Saúde
                                                        </option>
                                                        <option value="Marketing / Publicidade">
                                                            Marketing /
                                                            Publicidade
                                                        </option>
                                                        <option value="Engenharia / Arquitetura">
                                                            Engenharia /
                                                            Arquitetura
                                                        </option>
                                                        <option value="Educação / Cursos">
                                                            Educação / Cursos
                                                        </option>
                                                        <option value="Advocacia">
                                                            Advocacia
                                                        </option>
                                                        <option value="Consultoria">
                                                            Consultoria
                                                        </option>
                                                        <option value="Representação Comercial">
                                                            Representação
                                                            Comercial
                                                        </option>
                                                    </>
                                                )}
                                                {dados.tipoContrato ===
                                                    'Contratante' && (
                                                    <>
                                                        <option value="MEI (Microempreendedor Individual)">
                                                            MEI
                                                            (Microempreendedor
                                                            Individual)
                                                        </option>
                                                        <option value="ME (Microempresa)">
                                                            ME (Microempresa)
                                                        </option>
                                                        <option value="EPP (Empresa de Pequeno Porte)">
                                                            EPP (Empresa de
                                                            Pequeno Porte)
                                                        </option>
                                                        <option value="Média Empresa">
                                                            Média Empresa
                                                        </option>
                                                        <option value="Grande Empresa">
                                                            Grande Empresa
                                                        </option>
                                                    </>
                                                )}

                                                <option value="Outros...">
                                                    Outros...
                                                </option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="nome">
                                            <Form.Label>Nome*</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nome"
                                                value={dados.nome}
                                                onChange={handleChange}
                                                placeholder="Digite seu nome completo"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={6}>
                                        <Form.Group controlId="telefone">
                                            <Form.Label>Telefone*</Form.Label>
                                            <MaskedInput
                                                className="form-control"
                                                id="telefone"
                                                name="telefone"
                                                mask={[
                                                    '(',
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    ')',
                                                    ' ',
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    '-',
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                    /[0-9]/,
                                                ]}
                                                placeholder="(99) 99999-9999"
                                                guide={false}
                                                value={dados.telefone}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="email">
                                            <Form.Label>Email*</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={dados.email}
                                                onChange={handleChange}
                                                placeholder="usuario@provedor.com"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3 text-center">
                                    <Col md={12}>
                                        <Button
                                            style={{ width: '50%' }}
                                            onClick={handleCalculate}
                                        >
                                            Calcular
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>

                            {step === 'resultado' && (
                                <>
                                    <Row
                                        className="mt-5"
                                        style={{ padding: '15px' }}
                                    >
                                        <div className="cta">
                                            <Row>
                                                <Col
                                                    md={8}
                                                    className="text-area"
                                                >
                                                    Na Contabilidade Olímpia,
                                                    você pode economizar{' '}
                                                    <span className="txt-economizar">
                                                        {formatarParaReal(
                                                            resultadosPJ.ganhoLiquido -
                                                                resultados.ganhoLiquido
                                                        )}
                                                    </span>{' '}
                                                    em impostos neste cálculo se
                                                    emitir notas fiscais com um
                                                    CNPJ.
                                                </Col>
                                                <Col
                                                    md={4}
                                                    className="action-area"
                                                >
                                                    <a
                                                        href="https://api.whatsapp.com/send?phone=5511968591004&text=Preciso%20tirar%20d%C3%BAvida%20sobre%20o%20CNPJ"
                                                        target="_blank"
                                                        className="btn-cta"
                                                    >
                                                        Quero economizar!
                                                    </a>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Row>

                                    <Row className="mt-5">
                                        <Col md={6}>
                                            <h4>Profissional Autônomo</h4>
                                            <Table
                                                className="custom-table"
                                                striped
                                                bordered
                                                hover
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Descrição</th>
                                                        <th>Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Ganho Bruto</td>
                                                        <td>{` ${formatarParaReal(
                                                            resultados.ganhoBruto
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Imposto sobre
                                                            faturamento (DAS)
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.das
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>INSS</td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.inss
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Imposto de Renda
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.impostoRenda
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ISS</td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.iss
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Total de Descontos
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.totalDescontos
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ganho Líquido</td>
                                                        <td>{`${formatarParaReal(
                                                            resultados.ganhoLiquido
                                                        )}`}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                        <Col md={6}>
                                            <h4>Profissional com CNPJ</h4>
                                            <Table
                                                className="custom-table"
                                                striped
                                                bordered
                                                hover
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Descrição</th>
                                                        <th>Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Ganho Bruto</td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.ganhoBruto
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Imposto sobre
                                                            faturamento (DAS)
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.das
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>INSS</td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.inss
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Imposto de Renda
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.impostoRenda
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ISS</td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.iss
                                                        )}`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Total de Descontos
                                                        </td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.totalDescontos
                                                        )}`}</td>
                                                    </tr>
                                                    <tr
                                                        style={{
                                                            color: '#fff',
                                                        }}
                                                    >
                                                        <td>Ganho Líquido</td>
                                                        <td>{`${formatarParaReal(
                                                            resultadosPJ.ganhoLiquido
                                                        )}`}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </div>
                </Col>
                <Col sm={12} md={12} lg={4} style={{ marginBottom: '25px' }}>
                    <div
                        className="card main shadow-lg p-4 rounded custom-gradient"
                        style={{
                            background:
                                'linear-gradient(to bottom, #7cceee, #ffffff)',
                        }}
                    >
                        <h1>Abra seu CNPJ grátis com a Olímpia!</h1>
                        <div>
                            <p
                                className="text-center"
                                style={{
                                    marginBottom: '-10px',
                                    fontWeight: 600,
                                }}
                            >
                                Pague
                            </p>
                            <span
                                className="text-center"
                                style={{ fontSize: '40px', fontWeight: 700 }}
                            >
                                {' '}
                                SÓ AS TAXAS
                            </span>
                        </div>
                        <a
                            href="https://api.whatsapp.com/send?phone=5511968591004&text=Gostaria%20de%20abrir%20meu%20CNPJ"
                            style={{ marginTop: '20px', width: '100%' }}
                            target="_blank"
                            className="btn btn-primary"
                        >
                            QUERO SER PJ
                        </a>
                        <ul
                            style={{
                                listStyle: 'none',
                                textAlign: 'left',
                                marginTop: '20px',
                            }}
                        >
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Contratando um de nossos planos de
                                contabilidade,{' '}
                                <b>a abertura do seu CNPJ é grátis</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Otimizamos os impostos</b> do seu CNPJ para a
                                sua remuneração render.
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Emita notas fiscais e acompanhe sua empresa{' '}
                                <b>24h por dia</b> na nossa plataforma
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Escolha a forma de atendimento:{' '}
                                <b>WhatsApp, telefone, chat ou e-mail</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Planos com assessor que entende sua área</b>{' '}
                                e emite suas notas fiscais
                            </li>
                            {/* <li style={{marginTop: '3px'}}><FontAwesomeIcon icon={faCheck} color="#1b93c3" size={25}/> Contrate <b>planos de saúde até 30% mais baratos do que os para pessoa física</b></li> */}
                        </ul>
                    </div>
                </Col>
            </Row>

            <div className="bottom-cta-area">
                <div className="container">
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div style={{ display: 'flex'}}>
                                    <div 
                                        className="hide-mobile"
                                        style={{ width: 100 }}>
                                        <FontAwesomeIcon
                                            icon={faLightbulb}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        Acessoria especializada no seu
                                        seguimento
                                    </div>
                                    <div
                                        className='cta-btn-area'
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato#nossos-planos"
                                            style={{
                                                fontWeight: 700,
                                                color: '#1b93c3',
                                                borderWidth: '0.5px',
                                                borderColor: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Conheça nossos planos
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div 
                                    style={{ display: 'flex' }}>
                                    <div
                                        className="hide-mobile" 
                                        style={{ width: 100 }}>
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>
                                            Dúvidas?
                                        </span>
                                        <br />
                                        Entre em contato
                                    </div>
                                    <div
                                        className='cta-btn-area'
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato/"
                                            target="_blank"
                                            style={{
                                                fontWeight: 700,
                                                color: '#fff',
                                                borderWidth: '0.5px',
                                                background: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Fale com um especialista
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default CalculadoraRPA;
